import { Rol } from './rol';
import { Observable } from 'rxjs';
import { CategoriaPreguntasFrecuentes } from './categoria-preguntas-frequentes';

export class PreguntasFrecuentes {
  id: number;
  categoriaId: number;
  categoria: CategoriaPreguntasFrecuentes;
  rolId: number;
  rol: Rol;
  pregunta: string;
  preguntaPt: string;
  respuesta: string;
  respuestaPt: string;
  activo: boolean;
  orden: number;
  categoriaNombre: string;
  categoriaNombrePt: string;
}

export abstract class PreguntasFrecuentesData {
  abstract getList(): Observable<PreguntasFrecuentes[]>;
  abstract create(formData: FormData): Observable<any>;
  abstract update(formData: FormData): Observable<any>;
  abstract delete(documentId: number): Observable<any>;
  abstract getListByRol(id: number): Observable<PreguntasFrecuentes[]>;
}

